<template>
  <div>
    <div class="position-number justify-center align-center ma-2" v-if="!admin">
      <div class="position-number-big">{{ count }}</div>
      <div class="position-number-text">
        English speaking    
        <v-chip
          class="ma-2"
          v-if="keywords && !$vuetify.breakpoint.mobile"
          >
          {{ keywords }}
        </v-chip>
        jobs available
        <span v-if="area && !$vuetify.breakpoint.mobile" class="d-flex align-center ml-1">
          in 
          <v-chip
            class="ma-2"
            >
            {{ area }}
          </v-chip>
        </span>
      </div>
    </div>
    <div class="position-number" v-else>
      <div class="position-number-big">{{ reviewed }} / {{ count }}</div>
      <div class="position-number-text">
        Results reviewed
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PositionCount",
  props: {
    admin: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    count() {
      const { searchResults } = this.$store.state;
      var filteredData;
      console.log(filteredData);
      if(searchResults && searchResults !== null){
        filteredData = searchResults.filter((item) => item.match === true);
      }
      return filteredData ? Object.keys(filteredData).length : 0;
    },
    reviewed() {
      const { searchResults } = this.$store.state;
      let filteredData;
      console.log(filteredData);
      if(searchResults && searchResults !== null){
        filteredData = searchResults.filter(
          (item) => (item.status && item.status.reviewStatus !== "unreviewed") && item.match === true
        );
      }
      return filteredData ? Object.keys(filteredData).length : 0;
    },
    keywords() {
      return this.$store.state.searchTerms.keywords;
    },
    area() {
      return this.$store.state.searchTerms.area;
    },
  },
};
</script>

<style scoped>
.position-number {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  pointer-events: none;
  text-shadow: 0 0 5px #fff;
}
.position-number-big {
  font-size: 1em;
  line-height: 1em;
  padding: 0 0.4em;
  font-weight: 500;
}
.position-number-text {
  font-size: 1em;
  line-height: 1.2em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}
</style>
